import { Typography, Button, IconButton, Dialog, DialogContent } from '@material-ui/core';
import '../../styles/Globales.scss';
import '../../styles/SolicitarPortabilidad.scss';
import React, { Component } from 'react';
import TextRipleyComponent from './TextRipleyComponent';
import * as ValidationUtils from '../../utils/ValidationUtils';
import AutoCompletar from './AutoCompletar';
import { Info, Close } from '@material-ui/icons';

export default class DetalleCreditoComponent extends Component {
  state = {
    numeroCuenta: '',
    errorTxtNumeroCuenta: '',
    txtVigencia: '',
    montoDeuda: '',
    tipoProducto: {},
    openInfoMontoAdeudado: false,
    openInfoVigencia: false,
    openNumeroCuenta: false,
  };

  onChangeMontoDeuda = (evt) => {
    const num = evt.target.value;
    if (num) {
      const value = ValidationUtils.unformat(num);
      if (ValidationUtils.isNumberOrEmpty(value)) {
        this.setState({
          montoDeuda: value,
        });
      }
    } else {
      this.setState({
        montoDeuda: num,
      });
    }
  };

  onChangeNumeroCuenta = (evt) => {
    const num = evt.target.value;
    this.setState( (prevState) => {
      let numeroCuenta = prevState.numeroCuenta;
      let errorNumeroCuenta = false;
      let errortxtNumeroCuenta = '';
      if (ValidationUtils.isNumberOrEmpty(num) && num.length <= 6) {
        numeroCuenta = num;
      }
      if (numeroCuenta.length > 0 && numeroCuenta.length < 6) {
        errorNumeroCuenta = true;
        errortxtNumeroCuenta = 'Debes indicar los últimos 6 dígitos de tu número de cuenta';
      }
      return {
        numeroCuenta: numeroCuenta,
        errortxtNumeroCuenta: errortxtNumeroCuenta,
        errorNumeroCuenta: errorNumeroCuenta,
      }
    });
  };

  onChangeVigencia = (evt) => {
    const fecha = evt.target.value;// Verificar si la fecha es válida
    if (!isNaN(Date.parse(fecha))) {
      this.setState({
        txtVigencia: fecha,
        errorVigencia: false,
        errortxtVigencia: ' ',
      });
    }
  };

  onAgregar = () => {
    if (this.props.onAgregar) {
      const producto = {
        codProducto: this.state.tipoProducto.codProducto,
        nombreProducto: this.state.tipoProducto.nombreProducto,
        numeroCuenta: this.state.numeroCuenta,
        montoDeuda: this.state.montoDeuda,
        vigencia: this.formatDate(this.state.txtVigencia),
      };
      this.props.onAgregar(producto);
    }
    if (this.props.onCancelar) {
      this.props.onCancelar();
    }
  };

  formatDate(fecha) {
    if(!isNaN(Date.parse(fecha))) {
      const [year, month, day] = fecha.split("-");
      return `${day}-${month}-${year}`;
    } else {
      return '';
    }
  }

  onChangeTipoProducto = (combo, value, label) => {
    this.setState({ tipoProducto: { codProducto: value, nombreProducto: label } });
  };

  renderDetalleProducto = (tipoProducto) => {
    let result;
    if (tipoProducto.codProducto) {
      result = (
        <div className="bloqueSeleccionBanco">
          <div className="contenedorTextRipley contenedorMonto">
            <TextRipleyComponent
              className="TextRipley"
              label="Monto Adeudado"
              fullWidth={true}
              value={ValidationUtils.formatMonto(this.state.montoDeuda)}
              onChange={this.onChangeMontoDeuda}
              placeholder="(opcional)"
            />
            <div className="peso">$</div>
            <IconButton
              className="MontoAdeudado"
              onClick={() => {
                this.setState({ openInfoMontoAdeudado: true });
              }}
            >
              <Info></Info>
            </IconButton>
          </div>
          <div className="contenedorTextRipley">
            <TextRipleyComponent
              className="TextRipley"
              label="Idetificador del Crédito"
              fullWidth={true}
              value={this.state.numeroCuenta}
              error={this.state.errorNumeroCuenta}
              errorText={this.state.errorTxtNumeroCuenta}
              onChange={this.onChangeNumeroCuenta}
              placeholder="(opcional)"
            />
            <IconButton
              className="NumeroCuenta"
              onClick={() => {
                this.setState({ openNumeroCuenta: true });
              }}
            >
              <Info></Info>
            </IconButton>
          </div>

          <div className="contenedorTextRipley">
            <TextRipleyComponent
              type="date"
              label="Vigencia del Crédito"
              fullWidth={true}
              value={this.state.txtVigencia}
              error={this.state.errorVigencia}
              errorText={this.state.errortxtVigencia}
              onChange={this.onChangeVigencia}
              placeholder="(opcional)"
            />
            <IconButton
              className="VigenciaCredito"
              onClick={() => {
                this.setState({ openInfoVigencia: true });
              }}
            >
              <Info></Info>
            </IconButton>
          </div>
        </div>
      );
    }
    return result;
  };

  render() {
    return (
      <div>
        <Typography className="tituloStepSolicitud ">
          Elige tu <strong>crédito</strong> e ingresa el detalle. Presiona el boton <strong>"Agregar Producto"</strong> para agregarlo a tu bolsa de portabilidad
        </Typography>
        <Typography className="tituloStepSolicitudAcordeon margin-top">Créditos</Typography>
        <div className="autoCompletar">
          <AutoCompletar
            options={this.props.listaTiposProductos}
            placeholder="seleccione el tipo de crédito"
            nomCombo="cmbTiposCuentas"
            valor={this.state.tipoProducto?.codProducto}
            handleChange={this.onChangeTipoProducto}
          ></AutoCompletar>
        </div>
        {this.renderDetalleProducto(this.state.tipoProducto)}
        <div className="botones">
          <Button color="primary" id="btnAgregar" className="btnRipley" fullWidth={true} onClick={this.onAgregar} disabled={!this.state.tipoProducto?.codProducto}>
            Agregar Producto
          </Button>
        </div>
        <Dialog open={this.state.openInfoMontoAdeudado}>
          <DialogContent>
            <div className="cerrarBtnModal">
              <IconButton
                onClick={() => {
                  this.setState({ openInfoMontoAdeudado: false });
                }}
              >
                <Close></Close>
              </IconButton>
            </div>
            <Typography className="tituloModalCarnet">Monto Adeudado</Typography>
            <Typography>Monto del crédito que queda por pagar</Typography>
          </DialogContent>
          <div>
            <div className="franjaColores">
              <div className="rojo" />
              <div className="amarillo" />
              <div className="morado" />
            </div>
          </div>
        </Dialog>

        <Dialog open={this.state.openNumeroCuenta}>
          <DialogContent>
            <div className="cerrarBtnModal">
              <IconButton
                onClick={() => {
                  this.setState({ openNumeroCuenta: false });
                }}
              >
                <Close></Close>
              </IconButton>
            </div>
            <Typography className="tituloModalCarnet">Identificador del Crédito</Typography>
            <Typography>Últimos 6 dígitos del crédito</Typography>
          </DialogContent>
          <div>
            <div className="franjaColores">
              <div className="rojo" />
              <div className="amarillo" />
              <div className="morado" />
            </div>
          </div>
        </Dialog>

        <Dialog open={this.state.openInfoVigencia}>
          <DialogContent>
            <div className="cerrarBtnModal">
              <IconButton
                onClick={() => {
                  this.setState({ openInfoVigencia: false });
                }}
              >
                <Close></Close>
              </IconButton>
            </div>
            <Typography className="tituloModalCarnet">Vigencia del Crédito</Typography>
            <Typography>Fecha término del crédito</Typography>
          </DialogContent>
          <div>
            <div className="franjaColores">
              <div className="rojo" />
              <div className="amarillo" />
              <div className="morado" />
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

DetalleCreditoComponent.defaultProps = {
  listaTiposProductos: [],
};
